export const clean = (number: string) => {
  return number.toString().replace(/[^\d^+]/gm, '');
};

export const mask = (): ((rawValue: string) => (string | RegExp)[]) => () =>
  ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
